module.exports = __webpack_public_path__ + "img/guanbi.796b7320.png";